// An autoresize directive that works with ion-textarea in Ionic 2
// Usage example: <ion-textarea autoresize [(ngModel)]="body"></ion-textarea>
// Based on https://www.npmjs.com/package/angular2-autosize
import { ElementRef, HostListener, Directive, OnInit, Inject } from '@angular/core';

@Directive({
	selector: "ion-textarea[autoresize]" // Attribute selector
})
export class Autoresize implements OnInit {

	@HostListener("input", ["$event.target"])
	onInput(textArea: HTMLTextAreaElement): void {
		this.adjust();
	}
	constructor(@Inject(ElementRef) public element: ElementRef) {
	}
	ngOnInit(): void {
		setTimeout(() => this.adjust(), 0);
	}
	adjust(): void {
		let ta = this.element.nativeElement.querySelector("textarea");

		if (ta) {
			ta.style.overflow = "hidden";
			ta.style.height = "auto";
			ta.style.height = ta.scrollHeight + "px";
		}
	}

}


// WEBPACK FOOTER //
// ./src/pipes/autoresize.ts